var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6.667c0-.69.56-1.25 1.25-1.25h5A11.25 11.25 0 0 1 21.243 16.27 11.25 11.25 0 0 1 30 12.083h5c.69 0 1.25.56 1.25 1.25V15A11.25 11.25 0 0 1 25 26.25h-3.75v7.084a1.25 1.25 0 0 1-2.5 0V21.25H15A11.25 11.25 0 0 1 3.75 10zm15 10A8.75 8.75 0 0 0 10 7.917H6.25V10A8.75 8.75 0 0 0 15 18.75h3.75zm2.5 7.083v-.417a8.75 8.75 0 0 1 8.75-8.75h3.75V15A8.75 8.75 0 0 1 25 23.75z",
    clipRule: "evenodd"
  })));
};
export default SvgLeaf;